import { Box, Stack } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'
import { EmphasizedNumber, Icons } from 'utoniq-ui'

export type PointHeaderDisplayProps = {
  point: number | string
  size?: 'medium' | 'large'
  sx?: SxProps
}

export const PointHeaderDisplay: FC<PointHeaderDisplayProps> = ({
  point,
  size = 'medium',
  sx,
}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="flex-end"
      direction="row"
      sx={{
        position: 'relative',
        bgcolor: size === 'large' ? 'transparent' : 'grey.100',
        borderRadius: 3,
        height: 20,
        minWidth: size === 'large' ? 100 : 64,
        px: 2,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 32,
          position: 'absolute',
          display: 'grid',
          placeItems: 'center',
          left: -12,
        }}
      >
        <Icons.Point fontSize={size} />
      </Box>
      <EmphasizedNumber variant={size === 'medium' ? 'subtitle1' : 'h1'}>
        {point}
      </EmphasizedNumber>
    </Stack>
  )
}
